<template>
    <div class="tools" @keydown.esc="close()">
        <div class="tools-tab tools-tab-notes">
            <icon name="info" v-tooltip="$t('tooltip.roster.notes')" />
            <textarea v-model="notes" :placeholder="$t('tooltip.roster.notes')" maxlength="500" @keydown="handleKeys"></textarea>

            <a href="#" class="remove btn btn--red" v-on:click.prevent="remove()" v-if="notes">{{ $t('common.button.delete') }}</a>
            <a href="#" class="btn btn--green" v-on:click.prevent="save()">{{ $t('common.button.save') }}</a>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import events from '../../events/events';
import shared from '../../pages/planning/shared';

export default
{
    name: 'Notes',

    props: ['payload'],

    data() {
        return {
            shared: shared.state,
            notes: '',
        }
    },

    computed:
    {
        date()
        {
            return this.payload;
        },
    },

    created()
    {
        this.init();
    },

    watch:
    {
        payload()
        {
            this.init();
        }
    },

    methods:
    {
        init()
        {
            this.notes = shared.getNotes(this.date);

            events.$emit('tooltip.hide');
        },

        save(remove)
        {
            let notes = remove ? '' : this.notes;

            this.$http.put(
            '/api/locations/' + this.shared.location + '/notes/' + this.date, { 
                content: notes
            })
            .then(response =>
            {
                let key = _.findIndex(this.shared.notes, {date: this.date});

                if (key !== -1)
                {
                    if ( ! notes)
                    {
                        this.$delete(this.shared.notes, key);
                    }
                    else
                    {
                        // replace item
                        this.$set(this.shared.notes, key, {date: this.date, content: notes});
                    }
                }
                else if (notes)
                {
                    // add item
                    this.shared.notes.push({date: this.date, content: notes});
                }

                this.$tools.close();
            });
        },

        remove()
        {
            this.save(true); // remove
        },

        close()
        {
            events.$emit('toolbox.close');
        },

        handleKeys(e)
        {
            // no CTRL or CMD key pressed
            if ( ! (e.metaKey || e.ctrlKey)) return;

            let key = e.which || e.keyCode || 0;

            // select all (CTRL+A)
            if (key == 65)
            {
                // prevent roster items from being selected
                e.stopPropagation();
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// Notes.vue?00cd36a4